// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3LUUC","content":"ManualTimeModal_content__3Qc3_"};